import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'

export class UploadQrModalStore {
  constructor() {
    makeAutoObservable(this)
  }
}

export const uploadQrModal = mx.ref<UploadQrModalStore>()
